import { Directive, EventEmitter, Renderer2, ElementRef, HostListener, HostBinding } from "@angular/core";
import * as ɵngcc0 from '@angular/core';
var SuiSelectSearch = /** @class */ (function () {
    function SuiSelectSearch(_renderer, _element) {
        this._renderer = _renderer;
        this._element = _element;
        this.onQueryUpdated = new EventEmitter();
        this.onQueryKeyDown = new EventEmitter();
        this._searchClass = true;
        this._autoComplete = "off";
    }
    Object.defineProperty(SuiSelectSearch.prototype, "query", {
        set: function (query) {
            this._renderer.setProperty(this._element.nativeElement, "value", query);
        },
        enumerable: true,
        configurable: true
    });
    SuiSelectSearch.prototype.updateQuery = function (query) {
        this.onQueryUpdated.emit(query);
    };
    SuiSelectSearch.prototype.onKeyDown = function (e) {
        this.onQueryKeyDown.emit(e);
    };
    SuiSelectSearch.prototype.focus = function () {
        var _this = this;
        // Slightly delay to support in menu search.
        this._element.nativeElement.focus();
        setTimeout(function () { return _this._element.nativeElement.focus(); });
    };
    /** @nocollapse */
    SuiSelectSearch.ctorParameters = function () { return [
        { type: Renderer2, },
        { type: ElementRef, },
    ]; };
    SuiSelectSearch.propDecorators = {
        "_searchClass": [{ type: HostBinding, args: ["class.search",] },],
        "_autoComplete": [{ type: HostBinding, args: ["attr.autocomplete",] },],
        "updateQuery": [{ type: HostListener, args: ["input", ["$event.target.value"],] },],
        "onKeyDown": [{ type: HostListener, args: ["keydown", ["$event"],] },],
    };
SuiSelectSearch.ɵfac = function SuiSelectSearch_Factory(t) { return new (t || SuiSelectSearch)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SuiSelectSearch.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SuiSelectSearch, selectors: [["input", "suiSelectSearch", ""]], hostVars: 3, hostBindings: function SuiSelectSearch_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function SuiSelectSearch_input_HostBindingHandler($event) { return ctx.updateQuery($event.target.value); })("keydown", function SuiSelectSearch_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("autocomplete", ctx._autoComplete);
        ɵngcc0.ɵɵclassProp("search", ctx._searchClass);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiSelectSearch, [{
        type: Directive,
        args: [{
                selector: "input[suiSelectSearch]"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _searchClass: [{
            type: HostBinding,
            args: ["class.search"]
        }], _autoComplete: [{
            type: HostBinding,
            args: ["attr.autocomplete"]
        }], updateQuery: [{
            type: HostListener,
            args: ["input", ["$event.target.value"]]
        }], onKeyDown: [{
            type: HostListener,
            args: ["keydown", ["$event"]]
        }] }); })();
    return SuiSelectSearch;
}());
export { SuiSelectSearch };

